import { render, staticRenderFns } from "./WPTextInfoHeader.vue?vue&type=template&id=8e1cc760"
import script from "./WPTextInfoHeader.vue?vue&type=script&lang=ts"
export * from "./WPTextInfoHeader.vue?vue&type=script&lang=ts"
import style0 from "./WPTextInfoHeader.vue?vue&type=style&index=0&id=8e1cc760&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports